import { Alert } from 'antd';
import React, { useEffect, useState } from 'react'

function ChromeAlert() {
    const [isChrome,setIsChrome] = useState(true)
    useEffect(() => {
        const userAgent = navigator.userAgent;
        const isChrome = userAgent.includes('Chrome') && !userAgent.includes('Edg') && !userAgent.includes('QQBrowser') && !userAgent.includes('WOW64'); 
        if(isChrome){
            setIsChrome(true)
        }else{
            setIsChrome(false)
        }
    },[])     
    return (
        <>
            {!isChrome && <Alert 
                message={<>当前浏览器不是chrome浏览器，请使用chrome浏览器获取更好的使用体验！</>} 
                description={<a href='/download/ChromeCore_1198_5.1.8.14.exe'>点击下载chrome浏览器</a>} 
                type="warning" 
                showIcon
            />}
        </>
    )
}

export default ChromeAlert